export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '热门电视剧一网打尽，国产剧、韩剧、美剧、日剧应有尽有',
    icon: 'ri-tv-line',
    count: 128,
    imageSeq: 'category-dianshiju',
  },
  {
    slug: 'dianying',
    name: '电影',
    description: '最新电影大片，动作、喜剧、悬疑、爱情多种类型任你选',
    icon: 'ri-film-line',
    count: 256,
    imageSeq: 'category-dianying',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺节目，音乐、脱口秀、真人秀精彩不停',
    icon: 'ri-mic-line',
    count: 89,
    imageSeq: 'category-zongyi',
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '热血动漫、治愈番剧、经典国漫，二次元世界等你探索',
    icon: 'ri-ghost-line',
    count: 167,
    imageSeq: 'category-dongman',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '高品质纪录片，人文历史、自然地理、科技探索精彩呈现',
    icon: 'ri-earth-line',
    count: 73,
    imageSeq: 'category-jilupian',
  },
];